import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';

import { environment } from '@environments/environment';
import { Connector, Result } from '@app/_models';
import { types, authconfiguration } from '@app/_models';
//import { Triggers } from '@app/_models';
import { Triggers, TriggerApiCongigs, TriggerConfigURLs, TriggerConfigheaders, TriggerConfigbodys } from '../_models';

@Injectable({
  providedIn: 'root'
})
export class TriggerService {

  private triggerSubject: BehaviorSubject<Triggers>;
  public trigger: Observable<Triggers>;

  constructor(
    private http: HttpClient
  ) {
    this.triggerSubject = new BehaviorSubject<Triggers>(JSON.parse(localStorage.getItem('trigger')));
    this.trigger = this.triggerSubject.asObservable();
  }

  getAll(uId: string) {
    return this.http.get<Triggers[]>(`${environment.apiUrl}/trigger/gettriggers?uid=${uId}`);
  }

  getAuthenticate(uId: string) {
    return this.http.get<Result>(`${environment.apiUrl}/trigger/getauthentication?uid=${uId}`);
  }

  gettrigger(uId: string, cId: string) {
    return this.http.get<Triggers>(`${environment.apiUrl}/trigger/getTrigger?uid=${uId}&cid=${cId}`);
  }

  AddUpdateTrigger(trigger: Triggers) {
    return this.http.post<Result>(`${environment.apiUrl}/trigger/addupdateTrigger`, trigger);
  }
  remove(cId: string) {
    return this.http.post<Result>(`${environment.apiUrl}/trigger/deletetrigger?cid=${cId}`, cId);
  }
  AddUpdateTriggerApi(triggerapicongig: TriggerApiCongigs) {
    return this.http.post<Result>(`${environment.apiUrl}/trigger/addupdatetriggerapi`, triggerapicongig);
  }
  //gettriggerapi
  gettriggerapi(uId: string, tId: string) {
    return this.http.get<TriggerApiCongigs>(`${environment.apiUrl}/trigger/gettriggerapi?uid=${uId}&cid=${tId}`);
  }

  getAllURL(uId: string, tId: string) {
    return this.http.get<TriggerConfigURLs[]>(`${environment.apiUrl}/trigger/gettriggerapiURLs?uid=${uId}&tid=${tId}`);
  }
  getAllHeader(uId: string, tId: string) {
    return this.http.get<TriggerConfigheaders[]>(`${environment.apiUrl}/trigger/gettriggerapiheader?uid=${uId}&tid=${tId}`);
  }
  getAllBody(uId: string, tId: string) {
    return this.http.get<TriggerConfigbodys[]>(`${environment.apiUrl}/trigger/gettriggerapiBody?uid=${uId}&tid=${tId}`);
  }
}
